import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { FeldUnterkategoriesServiceModule } from '..';
import { FeldUnterkategoriesFilterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    FeldUnterkategoriesServiceModule
  ],
  declarations: [FeldUnterkategoriesFilterComponent],
  exports: [FeldUnterkategoriesFilterComponent],

})
export class FeldUnterkategoriesFilterComponentModule { }
